import React from 'react';
import { cn } from '../../lib/utils';

const Label = ({ className, ...props }) => {
  return (
    <label
      className={cn(
        'text-sm font-medium text-slate-700 dark:text-slate-300 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 transition-colors',
        className
      )}
      {...props}
    />
  );
};

export default Label;